import {
    useCallback,
} from 'react'

import {
    useMutation,
} from '@tanstack/react-query'

import requests from 'app/requests/Lane/LaneStatus.requests'
import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

export default ({
    id, onSuccess,
}: {
    id: number,
    onSuccess: (...args: any[]) => void
}) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessAssigning,
        onError,
    } = useHandleStatusRequest({
        title: 'Lane was rejected',
        id: 'LaneRejected',
        onSuccess,
    })

    const {
        mutate: reject,
    } = useMutation({
        mutationFn: (laneId: number) => {
            return simpleApi({
                ...requests.setAsRejectedPricing({
                    id: laneId,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessAssigning,
    })

    return useCallback(() => {
        reject(id)
    }, [
        reject,
        id,
    ])
}
